import { React, useEffect, useState } from 'react';
import img_leopardo_mamiferos from '../../../assets/images/img_leopardo_mamiferos.png';
import ico_mono from '../../../assets/icons/ico_mono.svg'
import VideoGroupsBanner from '../../../components/videoGroupsBanner';
import GroupInfoSection from '../../../components/groupInfoSection';
import GoToPage from '../../../components/goToPage';
import GroupsVideoFooter from '../../../components/groupsVideoFooter';
const MammalsScreen = ({ handle }) => {
  const arenoso = "https://drive.google.com/uc?export=download&id=1aM3soWjqgk3PIEHW4GW6-u8SfZUGqbML";

 const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

    useEffect(() => {
        handle(false);
        return () => handle(true);
    }, [handle]);

    return (
        <div className="bg-[#002E0F] h-full">
             {width > 1300 ? (
             <div>
 <div className="grid overflow-hidden lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 lg:grid-rows-1  gap-0 w-full h-full bg-[#002E0F] absolute">
                <div className="relative w-full lg:h-full">
                    <VideoGroupsBanner videoSource={arenoso} left="2%" />
                    <div className="h-full bg-[#002E0F] bottom-0 right-0 absolute z-30 pl-24 pt-10 pr-36">
                    <GoToPage
                page="/grupos"
                side="left"
                name="Atrás"
                fontsize="text-lg"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-4"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
                    </div>
                    <img loading="lazy"
                    
                    src={img_leopardo_mamiferos} 
                    alt="" 
                    className="w-full  pr-[19.7rem]   bottom-0 absolute" />


                </div>

                <GroupInfoSection
                webvrurl="https://niv4.vercel.app/"
                icon={ico_mono}
                title={<p>Mamíferos</p>}
                subTitle=""
                textFirstTab={<p>Junto con las aves, los mamíferos son el grupo más diverso en cuanto
                    a formas desarrolladas y adaptación a los distintos ambientes y
                    geografías. Los mamíferos incluyen desde murciélagos voladores
                    hasta ballenas azules. En ambientes marinos, los mamíferos han
                    desarrollado una serie de adaptaciones que les permiten vivir en
                    ambientes acuáticos. Sin importar si su hábitat es marino o terrestre,
                    todos comparten características como el pelo, las glándulas mamarias,
                    la viviparidad y la temperatura corporal interna mayor a la temperatura
                    ambiente.</p>}
                textSecondTab={<p>Dada su diversidad de formas y de dietas, los mamíferos también cumplen muchas funciones en la naturaleza; por ejemplo, la carnívora o la herbívora; otros, más bien, son pescadores, polinizadores, dispersores de semillas. Por ello, los mamíferos están muy influenciados por las condiciones de los sitios donde habitan</p>}
                textThirdTab={<p>Se recomienda monitorear la presencia de mamíferos terrestres
                    en los fragmentos de bosque secundario y bosques de galería
                    asociados a paisajes productivos mediante avistamientos, cámaras
                    trampa, registros de huellas y otros rastros, así como a través de
                    entrevistas. Se recomienda realizar el muestreo cada 6 meses.</p>}>
                </GroupInfoSection>
            </div>
             </div>
             ):(
             <div>
<div className="min-h-[100vh] grid grid-cols-1 h-full">
          <div className=" bg-[#002E0F] left-0  lg:pl-24 md:pl-10 sm:pl-10 pl-10 pt-32 pr-36 h-fit">
            <GoToPage
              page="/grupos"
              side="left"
              name="Atrás"
              fontsize="text-lg"
              textColor="text-white"
              borderType="border-b-2"
              borderColor="border-white"
              iconSize="h-4"
              iconColor="invert"
              iconMargin="mr-5"
            ></GoToPage>
          </div>
          <div style={{"z-index":"1"}}>
          <GroupInfoSection 
                webvrurl="https://niv4.vercel.app/"
                icon={ico_mono}
                title={<p>Mamíferos</p>}
                subTitle=""
                textFirstTab={<p>Junto con las aves, los mamíferos son el grupo más diverso en cuanto
                    a formas desarrolladas y adaptación a los distintos ambientes y
                    geografías. Los mamíferos incluyen desde murciélagos voladores
                    hasta ballenas azules. En ambientes marinos, los mamíferos han
                    desarrollado una serie de adaptaciones que les permiten vivir en
                    ambientes acuáticos. Sin importar si su hábitat es marino o terrestre,
                    todos comparten características como el pelo, las glándulas mamarias,
                    la viviparidad y la temperatura corporal interna mayor a la temperatura
                    ambiente.</p>}
                textSecondTab={<p>Dada su diversidad de formas y de dietas, los mamíferos también cumplen muchas funciones en la naturaleza; por ejemplo, la carnívora o la herbívora; otros, más bien, son pescadores, polinizadores, dispersores de semillas. Por ello, los mamíferos están muy influenciados por las condiciones de los sitios donde habitan</p>}
                textThirdTab={<p>Se recomienda monitorear la presencia de mamíferos terrestres
                    en los fragmentos de bosque secundario y bosques de galería
                    asociados a paisajes productivos mediante avistamientos, cámaras
                    trampa, registros de huellas y otros rastros, así como a través de
                    entrevistas. Se recomienda realizar el muestreo cada 6 meses.</p>}>
                </GroupInfoSection>
          </div>
          <div className="relative w-full lg:h-full flex justify-center lg:mt-44 md:mt-64 sm:mt-40 mt-40">
            <div className=" lg:mb-40 md:mb-32 sm:b-24 mb-24">
            <GroupsVideoFooter videoSource={arenoso} />
            </div>
            <img
            
              src={img_leopardo_mamiferos}
              alt=""
              className="lg:w-full md:w-full sm:w-full w-full h-fit-content bottom-0 absolute "
            />
          </div>
        </div>
             </div>
             )}
           
        </div>
    );
}

export default MammalsScreen;

